var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { DESKTOP_LOGO, MOBILE_LOGO, IMAGE_ALT } from "./constants";
import { Picture } from "../../../../compara-ui/components/Picture";
import { buildURL } from "./helpers";
export var Logo = function () { return (React.createElement("a", { href: "/", className: "flex items-center pl-4 md:pl-0 h-16" },
    React.createElement(Picture, { alt: IMAGE_ALT, src: buildURL(DESKTOP_LOGO), md: __assign(__assign({}, MOBILE_LOGO), { url: buildURL(MOBILE_LOGO) }), width: DESKTOP_LOGO.width, height: DESKTOP_LOGO.height, loading: "eager", usePixelDensity: true }))); };
//# sourceMappingURL=Logo.js.map